import { Box, Collapse, Divider, IconButton, Stack } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import DraggableComponent from '../DraggableComponent';
import type { DrawerCollapsibleWidget } from '../../../utils/electronicsDashboardUtils';

interface CollapsibleDraggableDataProps {
  data: DrawerCollapsibleWidget[];
}

const CollapsibleDraggableData = ({ data }: CollapsibleDraggableDataProps) => {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);

  const titleItem = data[0];
  const collapsibleItems = data.slice(1);

  const handleToggle = () => {
    setOpen((prev) => !prev);
  };

  return (
    <Stack sx={{ width: '100%' }} alignItems={'center'}>
      <Box sx={{ display: 'flex', alignItems: 'center' }}>
        <DraggableComponent {...titleItem} minH={titleItem.minH ?? 3} minW={titleItem.minW ?? 4} sx={{ cursor: 'move', m: 0 }} />
        <IconButton
          onClick={handleToggle}
          sx={{
            padding: 0,
            transform: open ? 'rotate(180deg)' : 'rotate(0deg)',
            transition: 'transform 0.3s ease',
          }}
          aria-label={open ? t('aria-label.collapse', 'collapse') : t('aria-label.expand', 'expand')}
        >
          <ExpandMoreIcon />
        </IconButton>
      </Box>

      <Collapse in={open}>
        <Divider />
        <Box sx={{ marginTop: 2 }}>
          {collapsibleItems.map((item) => (
            <DraggableComponent key={item.id} {...item} sx={{ marginY: 2 }} />
          ))}
        </Box>
      </Collapse>
    </Stack>
  );
};

export default CollapsibleDraggableData;
